import {Ims} from '@/api';

export const UploadStatus = {
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  ERROR: 'error',
  PENDING: 'pending',
  UPLOADING: 'uploading',
};

export const BINARY_TYPES = ['file', 'image'];

export async function deleteApp(app, notify, t) {
  try {
    const uri = `${app.namespace}/${app.version}`;
    await Ims.instance.api.delete(`/app-engine/tasks/${uri}`);

    notify({type: 'success', text: t('notify-success-app-deletion')});
  } catch (error) {
    console.error('Failed to delete app:', error);

    if (error.response?.status === 403) {
      notify({type: 'error', text: t('notify-error-app-deletion-forbidden')});
    } else {
      notify({type: 'error', text: t('notify-error-app-deletion')});
    }
  }
}

export async function installApp(app, notify, t) {
  try {
    const uri = `${app.namespace}/${app.version}`;
    await Ims.instance.api.post(`/app-engine/tasks/${uri}/install`);

    notify({type: 'success', text: t('notify-success-app-installation')});
    return true;
  } catch (error) {
    console.error('Failed to install app:', error);
    notify({type: 'error', text: t('notify-error-app-installation')});
    return false;
  }
}

export async function hasBinaryType(input) {
  const typeId = input.type.id === 'array' ? input.type.subType.id : input.type.id;
  return BINARY_TYPES.includes(typeId);
}

export function isGeometry(parameter) {
  if (parameter.type.id === 'geometry') {
    return true;
  }

  if (parameter.type.id === 'array' && parameter.type.subType.id === 'geometry') {
    return true;
  }

  return false;
}

export function formatTaskName(taskRun) {
  return `${taskRun.task.name} (${taskRun.task.version}) - ${(new Date(taskRun.createdAt)).toLocaleString()}`;
}
